import formbricks from "@formbricks/js"
import { DadosUsuarioIdentificator } from 'src/typescript/utils'
import { obterSecret } from 'src/typescript/servicos/bifrost/bifrost.servico'

export interface FormbricksInterface {
  registrarEmailUsuario: (emailUsuario: string) => void
  registrarAtributo: (nomeAtributo: string, valorAtributo: string) => void
  registrarGatilho: (nomeGatilho: string) => void
  registrarMudancaDeRota (): void
  deslogarFormbricks: () => Promise<void>
}

export default class Formbricks implements FormbricksInterface {
  private definirAmbiente (): string {
    const ambienteNode = process.env.NODE_ENV
    const ehaAmbientek8s = process.env.VUE_APP_K8s
    return ehaAmbientek8s ? 'development' : ambienteNode as string
  }

  public verificarSeUsuarioPermitido (emailUsuario: string): boolean {
    const usuarioEhLar21 = emailUsuario.includes('lar21')
    const usuararioEhPontotel = emailUsuario.includes('@pontotel')
    if (usuarioEhLar21 || usuararioEhPontotel) return false
    return true
  }

  public registrarEmailUsuario (emailUsuario: string): void {
    formbricks.setEmail(emailUsuario)
  }

  public registrarAtributo (nomeAtributo: string, valorAtributo: string): void {
    formbricks.setAttribute(nomeAtributo, valorAtributo)
  }

  public registrarGatilho (nomeGatilho: string): void{
    formbricks.track(nomeGatilho)
  }

  public registrarMudancaDeRota (): void {
    formbricks.registerRouteChange()
  }

  public async deslogarFormbricks (): Promise<void> {
    try {
      await formbricks.logout()
    } finally {
      localStorage.removeItem('formbricks-js')
    }
  }

  public async iniciarFormbricks (dadosDoUsuarioFormbricks: DadosUsuarioIdentificator): Promise<void> {
    if (typeof window !== 'undefined') {
      const { idUsuario, ...atributos } = dadosDoUsuarioFormbricks
      await formbricks.setup({
        environmentId: obterSecret('FORMBRICKS_KEY'),
        appUrl: process.env.VUE_APP_FORMBRICKS_URL as string,
      })

      await formbricks.setUserId(idUsuario)
      await formbricks.setAttributes({
        email: atributos.emailUsuario,
        nomeUsuario: atributos.nomeUsuario,
        papelUsuario: atributos.papelUsuario,
        idEmpresaUsuario: atributos.idEmpresaUsuario,
        nomeEmpresaUsuario: atributos.nomeEmpresaUsuario,
        tamanhoEmpresaUsuario: atributos.tamanhoEmpresaUsuario,
        canal: atributos.canal,
        dataCriacaoUsuario: atributos.dataCriacaoUsuario,
        dataCriacaoEmpresa: atributos.dataCriacaoEmpresa,
        semanasUsoUsuario: String(atributos.semanasUsoUsuario),
        mesesUsoUsuario: String(atributos.mesesUsoUsuario),
        semanasUsoEmpresa: String(atributos.semanasUsoEmpresa),
        mesesUsoEmpresa: String(atributos.mesesUsoEmpresa),
        ...atributos.infosImplantacao
      })
    }

  }

  public verificarUsuarioEmSessaoAtiva (): boolean {
    const dadosFormbricks = localStorage.getItem('formbricks-js')
    if (!dadosFormbricks) {
      return false
    }
    try {
      const dadosParseados = JSON.parse(dadosFormbricks)
      return dadosParseados && dadosParseados?.status !== 'error'
    } catch {
      return false
    }
  }

  public verificarFormbricksEstaAtivo (): boolean {
    return Boolean(formbricks)
  }
}
